/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { LocaleMapper } from '@gh/common-shared-data';
import { bitSet, date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';

import { MasterZoneListItemMapper } from '../master-zones/master-zone-list-item.mapper';
import { OfficeMapper } from '../offices/mappers/office.mapper';
import { UserAllowAccess } from '../users';
import { UserType } from '../users/user-type.enum';
import { ApplicationView } from './application-view.enum';
import { BuilderUserProfileDto, BuilderUserProfileValidationDto } from './builder-user-profile.dto';
import { SYSTEM_ROLES_BIT_SIZE } from './system-role.enum';
import { ValidationStatus } from './validation-status.enum';

export const BuilderUserProfileMapper = entity<BuilderUserProfileDto>({
  systemRoles: bitSet(SYSTEM_ROLES_BIT_SIZE),
  locale: LocaleMapper,
  appView: enumeration(ApplicationView),
  type: enumeration(UserType),
  validationResult: subentity<BuilderUserProfileValidationDto>({
    paymentStatus: enumeration(ValidationStatus),
  }),
  office: OfficeMapper,
  masterZone: MasterZoneListItemMapper,
  currentDateTime: date(DateFormat.DateTime),
  allowAccessToLeads: enumeration(UserAllowAccess),
});
